import React, { Component } from 'react';

import './Folder.css'

import { Layer } from '../Layer/Layer';

import expandImg from './.image/expand.png'
import collapseImg from './.image/collapse.png'
import folderImg from './.image/folder.png'

export class Folder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            expand: false
        }
    }

    render() {
        return (
            <li className='treeItem'>
                <div className='expandHeader' onClick={this.handleClick}>
                    <div style={{lineHeight: '20px'}}>
                        <img src={this.toggleImage()} width={16} height={16} alt="圖層_圖示"/>
                    </div>
                    {/*<input type="checkbox"
                        onClick={(e)=>{e.stopPropagation();}} 
                        onChange={this.handleLayerOpen}></input>*/}
                    <div style={{lineHeight: '20px'}}>
                        <img src={folderImg} width={16} height={16} alt="圖層_圖示"/>                                            
                    </div>
                    <span>{this.props.data.Name}</span>
                </div>
                <div className='expandBody' style={{
                    opacity: this.state.expand ? 1 : 0,
                    height: this.state.expand ? 'auto' : 0,
                }}>
                    <ul className='expandList'>
                        <div>
                            {this.parseData(this.props.data.Layers)}
                        </div>
                    </ul>
                </div>
            </li>
        );
    }

    parseData = (data) => {
        return data.map((item, index)=>{
            return (
                item.Class=="FOLDER" ?
                <Folder key={item.Name} data={item} /*name={item.Name} data={item.Layers} class={item.Class}*/ updateLayerList = {this.props.updateLayerList}/> :
                <Layer key={item.Name} data={item} /*name={item.Name} data={item.FolderFullName} class={item.Class}*/ updateLayerList = {this.props.updateLayerList}/>
            );
        });
    }

    handleLayerOpen = (event) => {
        if (event.currentTarget.checked === true) {
            this.props.updateLayerList.addLayerToList(this.props.data/*{
                Name: this.props.name,
                Data: this.props.data,
                Class: this.props.class
            }*/)
        } else {
            this.props.updateLayerList.removeLayerFromList(this.props.data/*{
                Name: this.props.name,
                Data: this.props.data,
                Class: this.props.class
            }*/);
        }
        event.stopPropagation();
    }

    handleClick = ()=>{
        this.setState({
            expand: !this.state.expand
        });
    }

    toggleImage = () => {
        return this.state.expand ? collapseImg : expandImg;
    }
}